/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import Swal from 'sweetalert2';
import './stylesComparativo.css';
import { Modal } from '@material-ui/core';
import { Steps } from 'primereact/steps';
import {
    enumStatusAceite,
    existePetNoPlano,
    formatarData,
    formatTipoCobranca,
    somaTotalPlanoMaisDepententes,
    statusEnvioAceite,
    validarTipoAceite
} from './funcoesAuxiliares';
import { ProgressSrinnerUpSell } from '../formatacaoTabela';
import { buscarDadosComparacaoPlanoMigrado, buscarDadosComparacaoUpSell } from '../../../services/upSell';
import EnvioDeAceite from '../envioDeAceite';
import { converterValorMonetarioParaNumero } from '../funcoesUpSell';

const TelaComparativo = props => {
    const [dadosComparativo, setDadosComparativo] = useState();
    const [openModalPlanos, setOpenModalPlanos] = useState(false);
    const [contatosAssociado, setContatosAssociado] = useState({});
    const [numeroStatusAceite, setNumeroStatusAceite] = useState(0);
    const [recarregarDadosCardes, setRecarregarDadosCardes] = useState(0);
    const [disabledEvioAceite, setDisabledEvioAceite] = useState(false);
    const [valorTotalMensal, setValorTotalmensal] = useState(false);
    const [planoMigrado, setPlanoMigrado] = useState(false);
    const [tituloDetalhesPlanoDestinoOuAnterior, setTituloDetalhesPlanoDestinoOuAnterior] = useState('Detalhes plano de destino');
    const [tituloDetalhesPlanoAtualOuComUpSell, setTituloDetalhesPlanoAtualOuComUpSell] = useState('Detalhes plano atual');
    const [tituloPrincipal, setTituloPrincipal] = useState('Comparativo entre planos');
    const history = useHistory();
    const infoPlanoMigrado = props.location.state?.planoMigrado;
    const { inscricao } = props.match.params;
    const commonCardStyle = {
        width: '100%',
        marginBottom: '1em',
        borderRadius: '10px',
        paddingTop: '3px'
    };

    const planoMigradoAtivo = () => {
        setPlanoMigrado(true);
        setTituloPrincipal('Análise de Migração de Planos');
        setTituloDetalhesPlanoAtualOuComUpSell('Detalhes plano Anterior (sem migração UpSell)');
        setTituloDetalhesPlanoDestinoOuAnterior('Detalhes plano atual (com migração UpSell)');
    };

    useEffect(() => {
        (async () => {
            let result;

            if (infoPlanoMigrado) {
                result = await buscarDadosComparacaoPlanoMigrado(inscricao);
                result.destino = result.atual;
                result.atual = result.historico;
                planoMigradoAtivo();
            } else {
                result = await buscarDadosComparacaoUpSell(inscricao);

                if (result && result.statusAceite === enumStatusAceite.migrado) {
                    planoMigradoAtivo();
                    result = await buscarDadosComparacaoPlanoMigrado(inscricao);
                    result.destino = result.atual;
                    result.atual = result.historico;
                }
            }

            if (result) {
                const valorTotalPlano = somaTotalPlanoMaisDepententes(result);

                setValorTotalmensal(valorTotalPlano);
                result.destino.plano.ValorTotal = converterValorMonetarioParaNumero(valorTotalPlano);

                setContatosAssociado({
                    AssEmail: result?.atual?.associado?.AssEmail,
                    Celular: result?.atual?.associado?.Celular
                });
                setDisabledEvioAceite(result.statusAceite == enumStatusAceite.migrado);
                setNumeroStatusAceite(validarTipoAceite(result.statusAceite || enumStatusAceite.pendente));
                setDadosComparativo(result);
            }
        })();
    }, [recarregarDadosCardes, inscricao, infoPlanoMigrado]);

    const cardHeader = title => (
        <span className="card-title-interno">{title}</span>
    );

    const renderCardPlano = (title, plano, renderizaCardEsquerdoTela = false) => {
        const infoPosicaoMensalidade = renderizaCardEsquerdoTela ? 'da próxima' : 'ultima';

        return (
            <Card
                header={cardHeader(title)}
                style={{
                    ...commonCardStyle,
                    backgroundColor: renderizaCardEsquerdoTela ? '#f0f8ff' : '#fff',
                    border: renderizaCardEsquerdoTela ? '2px solid #00BFFF' : '2px solid #ccc'
                }}
            >
                <p><strong>Descrição:</strong> {plano?.Descricao}</p>
                <p><strong>Subgrupo:</strong> {plano?.SubGrupo}</p>
                <p><strong>Valor Base:</strong> {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(plano?.ValorBase)}</p>
                <p><strong>Valor Total Mensal:</strong> {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(plano?.ValorTotal)}</p>
                {planoMigrado && (
                    <>
                        <p><strong>Data {infoPosicaoMensalidade} Mensalidade: </strong>{formatarData(plano?.Mensalidade?.DataPagamento)} </p>
                        <p><strong>Valor {infoPosicaoMensalidade} Mensalidade:</strong> {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }).format(plano?.Mensalidade?.Valor)}</p>
                        <p><strong>Vendedor:</strong>{plano?.NomeVendedor}</p>
                        <p><strong>Supervisor:</strong>{plano?.NomeSupervisor}</p>
                        <p><strong>Coordenador:</strong>{plano?.NomeCoordenador}</p>
                        {renderizaCardEsquerdoTela ? (
                            <p>&nbsp;</p>
                        ) : (
                            <p><strong>Carência: </strong>{formatarData(plano?.Carencia)}</p>
                        )}
                    </>
                )}
            </Card>
        );
    };

    const renderCardAssociado = (title, associado, renderizaCardEsquerdoTela = false) => {
        const vencimento = renderizaCardEsquerdoTela ? 'Proxímo Vencimento Dia' : 'Vencimento Dia';

        return (
            <>
                <Card
                    header={cardHeader(title)}
                    style={{
                        ...commonCardStyle,
                        backgroundColor: renderizaCardEsquerdoTela ? '#f0f8ff' : '#fff',
                        border: renderizaCardEsquerdoTela ? '2px solid #00BFFF' : '2px solid #ccc'
                    }}
                >
                    <p><strong>Forma de Pagamento:</strong> {formatTipoCobranca(associado.AssTipoCobranca)}</p>
                    <p><strong>{vencimento}:</strong> {associado.DiaVenc}</p>
                    <p><strong>Celular:</strong> {associado.Celular}</p>
                    <p><strong>Telefone:</strong> {associado.Telefone}</p>
                    <p><strong>Email:</strong> {associado.AssEmail}</p>
                    <p><strong>Endereço:</strong> {`
                        ${associado.Residencia},
                        ${associado.Bairro},
                        ${associado.Cidade},
                        ${associado.CEPResid},
                        ${associado.Complemento || ''}
                    `}
                    </p>
                    <p><strong>Referência:</strong> {associado.AssReferenciaEndereco}</p>
                </Card>
            </>
        );
    };

    const renderCardDependentes = (title, infoDependentes, renderizaCardEsquerdoTela = false) => (
        <Card
            header={cardHeader(title)}
            style={{
                ...commonCardStyle,
                backgroundColor: renderizaCardEsquerdoTela ? '#f0f8ff' : '#fff',
                border: renderizaCardEsquerdoTela ? '2px solid #00BFFF' : '2px solid #ccc'
            }}
        >
            <p><strong>Quantidade:</strong> {infoDependentes?.length}</p>
            <p><strong>Parentesco tipo Pet:</strong> {existePetNoPlano(infoDependentes)}</p>
            <hr />
            <br />
            {infoDependentes?.map((dependente, index) => (
                <div key={index}>
                    <p><strong>Nome:</strong> {dependente.Nome}</p>
                    <p><strong>Parentesco:</strong> {dependente.Parentesco}</p>
                    <p><strong>Categoria:</strong> {dependente['CategoriaParentesco.Descricao']}</p>
                    <p><strong>Nascimento: </strong>{formatarData(dependente.Nascimento)}</p>
                    <p><strong>Idade:</strong> {dependente.Idade}</p>
                    <p><strong>Sexo:</strong> {dependente.DepSexo}</p>
                    <p><strong>Valor:</strong> {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(dependente.valor)}</p>
                    {index < infoDependentes.length - 1 && <hr />}
                    <br />
                </div>
            ))}
        </Card>
    );

    const abrirModalAceite = async () => {
        if (dadosComparativo.statusAceite === enumStatusAceite.recusado) {
            const result = await Swal.fire({
                title: 'Contrato recusado pelo usuário',
                text: 'Deseja reenviar o contrato?',
                showCancelButton: true,
                confirmButtonColor: '#0d730d',
                cancelButtonColor: '#1b42cd',
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim'
            });

            if (result.isConfirmed) {
                setOpenModalPlanos(true);
            }
        } else {
            setOpenModalPlanos(true);
        }
    };

    const fecharModal = () => {
        setOpenModalPlanos(false);
        setRecarregarDadosCardes(prev => prev + 1);
    };

    const paginaAnterior = () => {
        history.push(`/cadastrar-dependentes/${inscricao}`);
    };

    const paginaInicialUpSell = () => {
        history.push('/up-sell');
    };

    return (
        <>
            <div className="titulo-comparativo">
                <h3>{tituloPrincipal}</h3>
            </div>
            {planoMigrado && (
                <div style={{
                    marginBottom: '12px',
                    color: '#001781'
                }}>
                    <span style={{ marginRight: '1vw' }}>
                        Forma de envio: {dadosComparativo?.dadosAceite?.tipoEnvio}
                    </span>
                    <span style={{ marginRight: '1vw' }}>

                        Destino envio: {dadosComparativo?.dadosAceite?.destinoEnvio}
                    </span>
                    <span>

                        Data aceite: {dadosComparativo?.dadosAceite?.dataAceite}
                    </span>
                </div>
            )}
            {dadosComparativo ? (
                <>
                    < div className="p-grid p-fluid p-justify-center container-grid-cards">
                        <div className='p-col-12 p-md-6 card-atual'>
                            <h2 className='cards-titulo'>{tituloDetalhesPlanoAtualOuComUpSell}</h2>
                            {renderCardPlano('Contrato', dadosComparativo?.atual.plano)}
                            {renderCardAssociado('Associado', dadosComparativo?.atual.associado)}
                            {renderCardDependentes('Dependentes', dadosComparativo?.atual.dependentes)}
                        </div>
                        <div className='p-col-12 p-md-6 card-up-sell'>
                            <h2 className='cards-titulo'>{tituloDetalhesPlanoDestinoOuAnterior}</h2>
                            {renderCardPlano('Contrato', dadosComparativo?.destino.plano, true)}
                            {renderCardAssociado('Associado', dadosComparativo?.destino.associado, true)}
                            {renderCardDependentes('Dependentes', dadosComparativo?.destino.dependentes, true)}
                        </div>
                    </div>
                    {!planoMigrado ? (
                        <div className="p-grid p-dir-col p-dir-md-row p-dir-lg-row p-dir-sm-col container-footer">
                            <div className='p-col-12 p-md-12 p-lg-4 p-sm-12 botoes-proximo-voltar'>
                                <Button
                                    label="Enviar Aceite"
                                    className='p-button-primary p-button-rounded ms-2'
                                    icon="pi pi-check"
                                    onClick={abrirModalAceite}
                                    disabled={disabledEvioAceite}
                                />
                                <Button
                                    label="Voltar"
                                    icon="pi pi-times"
                                    className="p-button-warning p-button-rounded botao-voltar"
                                    onClick={paginaAnterior}
                                />
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-6 p-sm-6 status-aceite-container">
                                <span className="status-aceite-label">Status UpSell:</span>
                                <Steps model={statusEnvioAceite} activeIndex={numeroStatusAceite} />
                            </div>
                        </div>
                    ) : (
                        <div className="p-grid p-dir-col p-dir-md-row p-dir-lg-row p-dir-sm-col container-footer">
                            <div className='p-col-12 p-md-12 p-lg-4 p-sm-12 botoes-proximo-voltar'>
                                <Button
                                    label="Voltar"
                                    icon="pi pi-times"
                                    className="p-button-warning p-button-rounded botao-voltar"
                                    onClick={paginaInicialUpSell}
                                />
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <ProgressSrinnerUpSell />
            )}
            <Modal
                open={openModalPlanos}
                onClose={fecharModal}
                disableEnforceFocus={false}
                aria-labelledby="server-modal-title"
                aria-describedby="server-modal-description"
            >
                <div className="modal-container-aceite">
                    <div className="modal-content-aceite">
                        <EnvioDeAceite
                            contatosAssociado={contatosAssociado}
                            inscricao={inscricao}
                            fecharModal={fecharModal}
                            valorTotalMensal={valorTotalMensal}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default TelaComparativo;